/** @jsxImportSource @emotion/react */
import React, { memo, Suspense } from 'react'
import { LicenseInformationDataFetcher } from '@signal/core/licenseInformation'
import { LicenseInformationPropsType } from './types'
import LicenseInformationSkeleton from './Skeleton'

export const LicenseInformationLoader: React.FC<LicenseInformationPropsType> = ({
  children,
  ...rest
}) => {
  // the Suspense prevents apps from going into a suspense state when loading this license information,
  // this is loaded after initial page load so can be jarring otherwise
  // only the skeleton here should go into the suspense state
  return (
    <Suspense fallback={<LicenseInformationSkeleton />}>
      <LicenseInformationDataFetcher {...rest}>
        {children}
      </LicenseInformationDataFetcher>
    </Suspense>
  )
}

export default memo(LicenseInformationLoader)
